(() => {
  'use strict';
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Set();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      if (media.matches || !target.animate) return;
      const animation=target.animate([{opacity:.6},{opacity:1}], {duration:360,easing:'ease-out'});
      active.add(animation);
      animation.finished.then(()=>active.delete(animation),()=>active.delete(animation));
    });
  },{threshold:.1}) : null;
  function init(root=document) {
    root.querySelectorAll('.featured--r11 .product-card,.template-collection .product-card').forEach(card=>{
      if (seen.has(card)) return;
      seen.add(card);
      if (observer && !media.matches && card.getBoundingClientRect().top>innerHeight) observer.observe(card);
    });
  }
  media.addEventListener('change',()=>{if(media.matches){observer?.disconnect();active.forEach(a=>a.cancel());active.clear();}});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
})();
